import { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Title from "./components/Title";
import Form from "./components/Form"; 
import Results from "./components/Results";
import Loading from "./components/Loading";
import Links from "./components/Links";
import Success from "./components/Success";
import './App.css';

export type ResultsStateType = {
  country: string;
  cityName: string;
  temperature: string;
  conditionText: string; 
  icon: string;
}

function App() {
    const [loading, setLoading] = useState<boolean>(false);
    const [city, setCity] = useState<string>("");
    const [results, setResults] = useState<ResultsStateType>({ 
        country: "",
        cityName: "",
        temperature: "", 
        conditionText: "",
        icon: ""
    });
    const getWeather = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        fetch(`https://api.weatherapi.com/v1/current.json?key=b613407f48da4f6d8be11256212102&q=${city}&aqi=no`)
            .then(res => res.json())
            .then(data => {
                setResults({
                    country: data.location.country,
                    cityName: data.location.name,
                    temperature: data.current.temp_c,
                    conditionText: data.current.condition.text,
                    icon: data.current.condition.icon
                })
                setCity("");
                setLoading(false);
            })
            .catch(err => alert("エラーが発生しました。ページをリロードして、もう一度トライしてください。"))
    }
    return (
        <Router>
        <Switch>
            <Route exact path="/">
                <div className="wrapper">
                    <div className="container">
                        <Title />
                        <Form getWeather={getWeather} city={city} setCity={setCity} />
                        {loading ? <Loading /> : <Results results={results} />}  
                    </div>
                </div>
            </Route>
            <Route exact path="/links" component={Links}/>
            <Route exact path="/success" component={Success}/>
        </Switch>
        </Router>
    );
}

export default App;
